export interface SearchState {
  value: string;
}

export const SET_SEARCH_INFO = 'SET_SEARCH_INFO';
